import { ICommonResponse } from '../services/response.interface';
import { AppDispatch } from '../store/store';
import { showTooltip } from '../store/actions/layoutActions';
import { ITooltip } from '../store/reducers/layoutReducer';
import { fnLocalizeFilter, ILocale } from '../services/localize.service';
import { IOrderBy } from '../components/UI/CustomTable/interface/interface.custom';
import { IConfig } from './interface';
// @ts-ignore
import NumberToCyrillic from 'number-to-cyrillic';

interface IFilterObject<T> {
  arr: T[],
  fields: string[],
  searchStr: string
}

// /**
//  * Поиск по нескольким полям в массиве
//  * @param arr - Исходный массив
//  * @param fields - поля по которым необходим поиск ['field']
//  * @param searchStr - строка поиска
//  */
// export function filterObject<T>({
//                                   arr,
//                                   fields = [''],
//                                   searchStr,
//                                 }: IFilterObject<T>) {
//   const findArr = arr.filter((item: any) => {
//     let isFindItem = false;
//     for (const field of fields) {
//       /* Если поле существует и в него входит подстрока */
//       isFindItem = item[field] && item[field].toString().toLowerCase().includes(searchStr.toLowerCase());
//       if (isFindItem) break;
//     }
//     return isFindItem;
//   });
//   return findArr.length > 0 ? findArr : [];
// }

/**
 * Поиск по нескольким полям в массиве
 * @param arr - Исходный массив
 * @param fields - поля по которым необходим поиск ['field']
 * @param searchStr - строка поиска
 */
export function filterObject<T>({
                                  arr,
                                  fields = [''],
                                  searchStr = '',
                                }: IFilterObject<T>) {

  const lowerCaseSearchStr = searchStr.toLowerCase();

  const findArr = arr.filter((item: any) => {
    return fields.some(field => {
      const fieldValue = item[field]?.toString()?.toLowerCase();
      return fieldValue && fieldValue.includes(lowerCaseSearchStr);
    });
  });

  return findArr.length > 0 ? findArr : [];
}


interface IFilterObjectNew<T> {
  arr: T[];
  searchStr: string;
}

export function filterObjectNew<T>({ arr, searchStr }: IFilterObjectNew<T>) {
  const lowerCaseSearchStr = searchStr.toLowerCase();

  const filteredBySearchStr = arr.filter((o: any) =>
    Object.values(o).some((value: any) =>
      String(value).toLowerCase().includes(lowerCaseSearchStr)
    )
  );

  return filteredBySearchStr;
}

/**
 * Запись в локальное хранилище
 * @param key
 * @param value
 */

export function setDataToLocalStorage(key: string, value: any) {
  localStorage.setItem(key, value);
}

/**
 * Получение данных из локального хранилища
 * @param key
 */

export function getDataFromLocalStorage(key: string) {
  return localStorage.getItem(key);
}

/**
 * Удаление объектов из локального хранилища
 * @param key
 */
export function delDataFromLocalStorage(key: string) {
  localStorage.removeItem(key);
}

/**
 * Функция изменения стэйта форм редактирования
 */
export function handleClickSaveEditorState(e: any, state: any, setChangeState: Function, setIsFormChange = (bool?: boolean) => {
}) {

  const { id, type, name = undefined, value = null, checked = null } = e.target;

  let data;
  switch (type) {
    case 'checkbox' : {
      data = { [id]: checked };
      break;
    }
    default : {
      if (id) {
        data = { [id]: value };
      } else {
        data = { [name]: value };
      }

    }
  }

  setChangeState({ ...state, ...data });
  setIsFormChange(true);
}

interface IRequestTooltip {
  res: ICommonResponse;
  locale: ILocale;
  dispatch: AppDispatch;
}

/* Тоолтип ответа на асинхронны запрос */
export function asyncRequestTooltip({ res, dispatch, locale }: IRequestTooltip) {
  let tooltip: ITooltip = { type: 'success', message: fnLocalizeFilter(locale, '_lang.error.1002') };

  if (res.errorCode) {
    tooltip = { type: 'error', message: fnLocalizeFilter(locale, `_lang.error.${res.errorCode}`) };
  } else if (res.errorCode !== 0) tooltip = { type: 'error', message: fnLocalizeFilter(locale, '_lang.error.1003') };

  dispatch(showTooltip(tooltip));

  return res.errorCode === 0;
}

interface IFieldSort {
  array: any[];
  orderBy: IOrderBy;
}

/* Сортировка полей на клиенте */
export function fieldSort({ array, orderBy: { field, order } }: IFieldSort) {
  return array.slice().sort(function(a: any, b: any) {
    if (order === 'desc') {
      if (a[field] > b[field]) {
        return 1;
      }
      if (a[field] < b[field]) {
        return -1;
      }
    } else {
      if (a[field] < b[field]) {
        return 1;
      }
      if (a[field] > b[field]) {
        return -1;
      }
    }
    // a должно быть равным b
    return 0;
  });
}

/* Форматирование номера карты для водителя */
export const formatDriverCard = (card: string) => {
  const space = 4;
  let newCard = '';

  for (let i = 0; i < card.length; i++) {
    if (i % space === 0) newCard += ' ';
    newCard += card[i];
  }

  return newCard;

};

/* Конвертирование числа месяца в текст */
export const convertMonthToString = (monthNumber: string) => {
  switch (monthNumber) {
    case '01':
      return 'січня';
    case '02':
      return 'лютого';
    case '03':
      return 'березня';
    case '04':
      return 'квітня';
    case '05':
      return 'травня';
    case '06':
      return 'червня';
    case '07':
      return 'липня';
    case '08':
      return 'серпня';
    case '09':
      return 'вересня';
    case '10':
      return 'жовтня';
    case '11':
      return 'листопада';
    case '12':
      return 'грудня';

  }
};


export const getConfigFromFile = async (): Promise<IConfig> => {
  const setting = await fetch('config.json').then(function(response) {
    return response.json();
  });

  return setting && setting;
};


/**
 * Конвертирование цифр в текст прописью
 */
interface INumberToCyrillic {
  /**
   * Текстовое представление после запятой
   */
  convertedFractional: string;
  /**
   *  Текстовое представление до запятой
   */
  convertedInteger: string;
  /**
   * Цифровое представление после запятой
   */
  fractional: number;
  /**
   * копійок
   */
  fractionalCurrency: string;
  /**
   *  "00"
   */
  fractionalString: string;
  /**
   * Цифровое представление
   */
  integer: number;
  /**
   * Валюта (гривень)
   */
  integerCurrency: string;
  /**
   * Короткое название валюты (грн)
   */
  shortName: string;
}

export const getNumberToString = (number: number): INumberToCyrillic => {
  return NumberToCyrillic.convert(number, { capitalize: true });
};
